import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import AsyncSelect from "react-select/async";
import "./ParticipantCard.css";
import { arIsReadonly } from "../../redux/analyseRisques/analyseRisquesStatusActions";
import {
    setRisks,
    setParticipants,
    getDefaultParticipant,
    getMaxParticipantId,
    getParticipantType,
} from "../../redux/analyseRisques/analyseRisquesActions";
import { searchSubcontractors } from "../../redux/tiers/tiersActions";
import { TYPING_TIMEOUT } from "../../constants";
import CustomizedTextField from "../Input/CustomizedTextField";
import TextFieldWithTypingTimeout from "../Input/TextFieldWithTypingTimeout";
import { clone } from "../../utils";
import { NB_PARTICIPANT_MAX } from '../../redux/analyseRisques/analyseRisquesConstants';

const customControlStyles = () => ({
    height: "150px",
    overflow: "auto",
});

class ParticipantCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.currentParticipant.name,
            works: props.currentParticipant.works,
            numberOfParticipants: props.currentParticipant.numberOfParticipants,
            numberOfInterimaires: props.currentParticipant.numberOfInterimaires,
            typingTimeout: TYPING_TIMEOUT,
        };
    }

    deleteParticipant() {
        const data = this.props.currentParticipants;
        let indexOfParticipantToDelete = this.props.currentParticipantIndex;

        if (
            indexOfParticipantToDelete !== undefined &&
            indexOfParticipantToDelete >= 0
        ) {
            data.splice(indexOfParticipantToDelete, 1);
            this.setParticipants(data);
        }
    }

    addParticipant() {
        const currentParticipants = this.props.currentParticipants;
        currentParticipants.push(
            getDefaultParticipant(
                getMaxParticipantId(this.props.currentParticipants) + 1,
                this.props.currentParticipants
            )
        );
        this.setParticipants(currentParticipants);
    }

    typeChange(e) {
        let participants = this.props.currentParticipants;
        let currentParticipant =
            participants[this.props.currentParticipantIndex];
        currentParticipant.typeId = e.target.value;
        this.setParticipants(participants);
    }

    onWorksChange(value) {
        const participants = clone(this.props.currentParticipants);
        let participant = participants.find(
            (c) => c.id === this.props.currentParticipant.id
        );
        participant.works = value;
        this.setParticipants(participants);
    }

    onNumberOfParticipantsChange(value) {
        const participants = clone(this.props.currentParticipants);
        let participant = participants.find(
            (c) => c.id === this.props.currentParticipant.id
        );
        participant.numberOfParticipants = value;
        this.setParticipants(participants);
    }

    onNumberOfInterimairesChange(value) {
        const participants = this.props.currentParticipants;
        let participant = participants.find(
            (c) => c.id === this.props.currentParticipant.id
        );
        participant.numberOfInterimaires = value;
        this.setParticipants(participants);
    }

    onSupplierChange(selectedOption) {
        if (this.state.supplierTimeout)
            clearTimeout(this.state.supplierTimeout);

        const participants = this.props.currentParticipants;
        let participant = participants.find(
            (c) => c.id === this.props.currentParticipant.id
        );

        if (selectedOption) {
            participant.supplier = selectedOption;
            participant.tabletSupplierRef = selectedOption.label;
        } else {
            participant.supplier = null;
            participant.tabletSupplierRef = "";
        }

        this.setState({ supplier: "" });
        this.setParticipants(participants);

        // Ajout du participant comme participant concerné pour chaque solution des risques renseignés
        let currentRisks = [...this.props.currentRisks];
        currentRisks.forEach((currentRisk) => {
            let solutions = [...currentRisk.solutions];
            solutions.forEach((solution) => {
                let concernedCompany = solution.concernedCompanies.find((c) => c.company.id === this.props.currentParticipant.typeId);
                concernedCompany.concerned = selectedOption ? true : false;
            });
        });

        this.props.setRisks(currentRisks);
    }

    onInputChange(value, action) {
        if (action.action === "input-blur" || action.action === "menu-close")
            return;

        if (action.action === "set-value") {
            this.setState({ supplier: "" });
            return;
        }

        if (this.state.supplierTimeout)
            clearTimeout(this.state.supplierTimeout);

        this.setState({
            supplier: value,
            supplierTimeout: setTimeout(() => {
                const participants = this.props.currentParticipants;
                let participant = participants.find(
                    (c) => c.id === this.props.currentParticipant.id
                );
                participant.tabletSupplierRef = value;
                participant.supplier = null;
                this.setParticipants(participants);
            }, this.state.typingTimeout),
        });
    }

    setParticipants(participants) {
        this.props.setParticipants(
            this.props.currentRisks,
            this.props.raCompanies,
            this.props.sppCompanies,
            participants,
            this.props.moduleSpp
        );
    }

    loadOptions = (inputValue, callback) => {
        const requestResults = this.props.searchSubcontractors(
            inputValue,
            true
        );
        const minLengthOfSupplierCode = 2;

        if (inputValue.length < minLengthOfSupplierCode) callback([]);

        requestResults.then((response) => {
            callback(
                response.map(function (item) {
                    return {
                        value: item.id,
                        label:
                            "[" +
                            item.supplier_code +
                            "] " +
                            item.name +
                            ": " +
                            item.city +
                            " (" +
                            item.zip +
                            ")",
                    };
                })
            );
        });
    };

    render() {
        if (this.props.currentParticipant.id === 0) {
            if (this.props.currentParticipants.length >= NB_PARTICIPANT_MAX) return <div></div>;

            return (
                <div className="col-lg-4 col-md-6 col-sm-12 col-12 participant-card-container">
                    <Card className="card without-padding add-participant-card">
                        <CardContent
                            className={
                                this.props.readonly
                                    ? "disabled without-padding"
                                    : "without-padding"
                            }
                        >
                            <IconButton
                                className="participant-card-icon-container"
                                onClick={this.addParticipant.bind(this)}
                            >
                                <AddIcon className="participant-card-full-size-icon" />
                            </IconButton>
                        </CardContent>
                    </Card>
                </div>
            );
        }

        let title;
        let participantType = getParticipantType(
            this.props.currentParticipant.typeId
        );

        if (this.props.currentParticipant.supplier)
            title = this.props.currentParticipant.supplier.label;
        else title = this.props.currentParticipant.tabletSupplierRef;

        if (this.props.currentParticipantIndex === 0) {
            let customer = null;
            if (
                this.props.header.ot &&
                this.props.header.ot.affair &&
                this.props.header.ot.affair.customer
            )
                customer = this.props.header.ot.affair.customer;
            else if (
                this.props.header.affair &&
                this.props.header.affair.customer
            )
                customer = this.props.header.affair.customer;

            if (customer) title = customer.name;
            else title = "EU";
        }

        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 participant-card-container">
                <Card
                    className={
                        "card without-padding " +
                        (arIsReadonly(this.props.header) ? "disabled" : "")
                    }
                >
                    <CardHeader
                        style={{ color: "rgb(117, 117, 117)" }}
                        title={title}
                    />
                    <CardContent
                        className={
                            this.props.readonly
                                ? "disabled without-padding"
                                : "without-padding"
                        }
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id={
                                    this.props.currentParticipantIndex + "-type"
                                }
                                required
                                label={"Type de participant"}
                                className="full_size"
                                value={
                                    participantType ? participantType.name : ""
                                }
                                disabled
                            />
                        </div>
                        <div
                            className={
                                this.props.currentParticipant.canChangeName
                                    ? "col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top"
                                    : "hidden "
                            }
                        >
                            <AsyncSelect
                                loadOptions={this.loadOptions.bind(this)}
                                styles={{
                                    menuList: customControlStyles,
                                    menuPortal: customControlStyles,
                                }}
                                isClearable={true}
                                onInputChange={this.onInputChange.bind(this)}
                                onChange={this.onSupplierChange.bind(this)}
                                inputValue={this.state.supplier}
                                placeholder={
                                    this.props.currentParticipant.customer
                                        ? "Client"
                                        : "Sous traitant"
                                }
                                noResultsText={"Sous traitant introuvable"}
                                noOptionsMessage={() =>
                                    "Saisissez au moins 2 caractères"
                                }
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <TextFieldWithTypingTimeout
                                id={
                                    this.props.currentParticipantIndex +
                                    "-works"
                                }
                                label={"Travaux"}
                                required
                                className="full_size"
                                value={this.props.currentParticipant.works}
                                onValueChange={this.onWorksChange.bind(this)}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <TextFieldWithTypingTimeout
                                id={
                                    this.props.currentParticipantIndex +
                                    "-nb-participants"
                                }
                                label={"Nombre de participants"}
                                className="full_size"
                                required
                                value={this.props.currentParticipant.numberOfParticipants}
                                type="number"
                                onValueChange={this.onNumberOfParticipantsChange.bind(
                                    this
                                )}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <TextFieldWithTypingTimeout
                                id={
                                    this.props.currentParticipantIndex +
                                    "-whose-interim"
                                }
                                label={"Dont intérimaires"}
                                className="full_size"
                                required
                                value={this.props.currentParticipant.numberOfInterimaires}
                                type="number"
                                onValueChange={this.onNumberOfInterimairesChange.bind(
                                    this
                                )}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        currentParticipants: state.analyseRisques.participants,
        participantTypes: state.analyseRisques.participantTypes,
        currentRisks: state.analyseRisques.risks,
        moduleSpp: state.analysesRisques.moduleSpp,
        raCompanies: state.analyseRisques.raCompanies,
        sppCompanies: state.analyseRisques.sppCompanies,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setParticipants: (risks, companies, participants, moduleSpp) =>
            dispatch(
                setParticipants(risks, companies, participants, moduleSpp)
            ),
        setRisks: (risks, riskTypes, header, oldRisks, allPpe) =>
            dispatch(setRisks(risks, riskTypes, header, oldRisks, allPpe)),
        searchSubcontractors: (input, subcontractorOnly) =>
            searchSubcontractors(input, subcontractorOnly),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ParticipantCard);
